import {
  ActionIcon,
  Avatar,
  Center,
  Group,
  MediaQuery,
  Menu,
  Text,
} from "@mantine/core";
import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Edit, Logout } from "tabler-icons-react";

const logoutFunction = () => {
  localStorage.removeItem("userData");
  localStorage.removeItem("userRole");
  window.location.href = "/";
};

const LoggedInUserProfile = ({ internalLinks }) => {
  const [userDetails] = useState(
    localStorage.getItem("userData")
      ? JSON.parse(localStorage.getItem("userData"))
      : {}
  );
  return (
    <Menu trigger="hover" position="bottom">
      <Menu.Target>
        <Group>
          <ActionIcon>
            <Avatar size={"md"} radius="xl" src={userDetails?.logo} />
          </ActionIcon>
          <MediaQuery smallerThan={"md"} styles={{ display: "none" }}>
            <Text size="lg" color={"white"} className="menu-hover">
              {userDetails?.firstName} {userDetails?.lastName}
            </Text>
          </MediaQuery>
        </Group>
      </Menu.Target>
      <Menu.Dropdown>
        <MediaQuery largerThan={"md"} styles={{ display: "none" }}>
          <Menu.Label style={{ color: "black" }}>
            <Center>
              <Text size="lg" align="center">
                {userDetails?.firstName} {userDetails?.lastName}
              </Text>
            </Center>
            <Menu.Divider />
          </Menu.Label>
        </MediaQuery>

        {internalLinks?.map((e, i) => (
          <Menu.Item key={i} component={Link} to={e.link} icon={e.icon}>
            {e.label}
          </Menu.Item>
        ))}

        <Menu.Item onClick={logoutFunction} icon={<Logout />}>
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default LoggedInUserProfile;
